import orders from "./orders";

export const nshop = {
    orders,
};

export default nshop;
